import { RequireAuthentication } from '../../security';
import { CurrentUserProvider } from '../../providers/CurrentUserProvider';
import { AuthenticatedLayoutProps } from './AuthenticatedLayout.props';

export const AuthenticatedLayout = ({ children }: AuthenticatedLayoutProps) => (
  <RequireAuthentication>
    <CurrentUserProvider>{children}</CurrentUserProvider>
  </RequireAuthentication>
);
